import { useState } from "react";
import { Button, ContentContainer, ErrorMessage, LeadContainer, LeadLi, LeadText, LeadTitle, LeadUl, ModalInput, PrivacyText } from "./LeadModal.style";
import { BloomreachAnalysisLeadModel } from "../../../../types/BloomreachAnalysisLeadModel";

interface Props {
    isDesktop: boolean;
    onSendLead: (leadData: Pick<BloomreachAnalysisLeadModel, "firstName" | "email" | "phone">) => void;
    title?: string;
    text?: string;
    buttonText?: string;
}

export default function LeadModal({ isDesktop, onSendLead, title = "Få din udvidede adfærdsanalyse", text = "Få konkrete råd til netop din profil, som gør det nemmere for dig at styrke dine resultater - både privat og på arbejde. Indtast dine oplysninger og få analysen sendt direkte til din mail.", buttonText = "Send mig min analyse" }: Props) {

    const [firstName, setFirstName] = useState<string>();
    const [mobile, setMobile] = useState<string>();
    const [email, setEmail] = useState<string>();
    const [showMobileError, setShowMobileError] = useState<boolean>(false);
    const [showFirstNameError, setShowFirstNameError] = useState<boolean>(false);
    const [showEmailError, setShowEmailError] = useState<boolean>(false);
    const [consentChecked, setConsentChecked] = useState<boolean>(false);
    const [showConsentError, setShowConsentError] = useState<boolean>(false);

    const lead: Pick<BloomreachAnalysisLeadModel, "firstName" | "email" | "phone"> = {
        firstName: firstName as string,
        phone: mobile as string,
        email: email as string,
    };

    //Email validation
    const getEmailIsValid = (value: string) => {
        const normalizedEmail = value.trim();
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail);
    };

    //Validation for inputs
    const checkSubmit = () => {
        if ((firstName != undefined && firstName != "") && (mobile != undefined && mobile != "") && (email && getEmailIsValid(email)) && consentChecked) {
            onSendLead(lead);
            setFirstName("");
            setMobile("");
            setEmail("");
            setConsentChecked(false);
            setShowMobileError(false);
            setShowFirstNameError(false);
            setShowEmailError(false);
            setShowConsentError(false);
        } else {
            if (!firstName || firstName.trim() === "") {
                setShowFirstNameError(true);
            }
            if (!mobile || mobile.trim() === "") {
                setShowMobileError(true);
            }
            if (!email || !getEmailIsValid(email)) {
                setShowEmailError(true);
            }
            if (!consentChecked) {
                setShowConsentError(true);
            }
        }
    };

    return (
        <LeadContainer isDesktop={isDesktop}>
        <ContentContainer id="behaviour-form">
            <LeadTitle>{title}</LeadTitle>
            <LeadText>{text}</LeadText>
          
        </ContentContainer>
            <ModalInput id="name" type="text" placeholder="Dit navn" autoComplete="given-name"  
                onChange={(e) => {
                    setFirstName(e.currentTarget.value);
                }}
            />
            {showFirstNameError && (firstName === undefined || firstName === "") &&
                <ErrorMessage>Hov, her skal dit navn stå</ErrorMessage>
            }
            <ModalInput id="tel" type="tel" placeholder="Dit telefonnummer" autoComplete="tel"
                onChange={(e) => {
                    setMobile(e.currentTarget.value);
                }}
            />
            {showMobileError && (mobile === undefined  || mobile === "") && 
                <ErrorMessage>Hov, vi kan ikke ringe til dig uden telefonnummer</ErrorMessage>
            }
            <ModalInput
                id="email"
                type="email"
                placeholder="Din email"
                autoComplete="email"
                value={email}
                onChange={(e) => {
                    setEmail(e.currentTarget.value);
                }}
            />
            {showEmailError && <ErrorMessage>Hov, indtast en gyldig email</ErrorMessage>}
            <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "24px", marginTop: "20px" }}>
                <input
                    type="checkbox"
                    id="acceptContact"
                    checked={consentChecked}
                    onChange={(e) => {
                        setConsentChecked(e.target.checked);
                        if (showConsentError) setShowConsentError(!e.target.checked);
                    }}
                    className="customCheckbox"
                    style={showConsentError ? { outline: "2px solid var(--color-alert-color)", outlineOffset: "2px" } : undefined}
                />
                <span className="checkmark"></span>
                <label htmlFor="acceptContact" style={{ fontSize: "12px", color: "#fff", cursor: "pointer", width: "90%", textAlign: "left", marginLeft: "4px" }}>
                    Ase må gerne ringe til mig for at vejlede mig om deres medlemskaber og sende mig særlige tilbud - herunder fra <a target="_blank" href="https://www.ase.dk/gdpr/ase-a-kasse-samarbejdspartnere" style={{ textDecoration: "underline" }}>fordelspartnere</a> - via e-mail og sms. Mit samtykke kan altid trækkes tilbage*.
                </label>
            </div>
            {showConsentError && <ErrorMessage>Hov, du skal give samtykke for at fortsætte</ErrorMessage>}
            <Button className="button" onClick={checkSubmit} active={true}>{buttonText}</Button>
            <PrivacyText href="https://www.ase.dk/cookie-privatliv-og-persondata" target="_blank">Sådan behandler vi dine oplysninger</PrivacyText>
        </LeadContainer>
    );
}